












































































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import { ParamData } from "../../lib/requests.type";
import { RequestsModule } from "@/store/requests.module";
import { translate } from "@/utils";
import PhoneMask from "@/components/ui/PhoneMask.vue";
import FormValidator from "@/mixins/FormValidator";
import { AuthModule } from "@/store/auth.module";
import VCleaveInput from "vuetify-cleave";
import { BaseModule } from "@/store/base.module";

@Component({ components: { "phone-mask": PhoneMask, VCleaveInput } })
export default class NewContract extends Mixins(FormValidator) {
  formRef = "form";
  formData: ParamData = new ParamData();
  accept: boolean = false;
  loading: boolean = false;
  ReadOnly: boolean = false;

  get Message() {
    const mess = this.user.first_boss_name
      ? this.$t("requests.message_for_accept", {
          name: this.user.first_boss_name,
        })
      : "";
    return mess;
  }

  get BIK() {
    return this.formData.bank_name
      ? this.BanksForRefs.find((x) => x.record_id === this.formData.bank_name)
          ?.bank_bic
      : "";
  }

  get OrgTypes() {
    return translate(RequestsModule.OrgTypes);
  }
  get BanksForRefs() {
    const res = translate(RequestsModule.BanksForRefs);
    if (res && res.length > 0)
      res.sort((a, b) => a.company_name.localeCompare(b.company_name));
    return res;
  }
  get RefRegions() {
    return translate(RequestsModule.RefRegions);
  }
  get OrgBranches() {
    const list = RequestsModule.OrgBranches.filter(
      (x) =>
        x.region_code_name.toLowerCase() ===
        RequestsModule.RefRegions.filter(
          (r) => r.record_id === this.formData.region_name,
        )[0].code_name,
    );
    if (!list.find((x) => x.record_id === this.formData.azhk_org_branch))
      this.formData.azhk_org_branch = null as any;
    return translate(list);
  }
  get user() {
    return AuthModule.user as IUser;
  }
  async saveRequest() {
    try {
      if (!this.validateForm()) return;
      this.loading = true;
      const id = this.$route.params.id;
      const requestBody = {
        contractor_rid: this.user.record_id,
        record_id: id ? id : (null as any),
        params: this.formData,
      };
      await RequestsModule.addEditReq(requestBody).then((res) => {
        this.$router.push("/attachments/" + res.record_id);
      });

      BaseModule.showMessage({
        message: "requests.req_saved",
        color: "success",
      });
    } finally {
      this.loading = false;
    }
  }

  getParam(code_name: string): any {
    return RequestsModule.reqDetailList.find(
      (item) => item.code_name === code_name,
    )?.param_value;
  }

  async mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.ReadOnly =
        RequestsModule.SelectedItem && !RequestsModule.SelectedItem.can_edit;
      await RequestsModule.getContractorRequest(Number.parseInt(id));
      Object.keys(this.formData).forEach((key) => {
        const str = key as keyof typeof ParamData;
        (this.formData as any)[str] = this.getParam(key);
      });
    }
  }
}
